import i18next from 'i18next';
import ptBR from './translations/pt-br/translations.json';
import enUS from './translations/en-us/translations.json';
import esES from './translations/es-es/translations.json';

export type Langs = 'pt-br' | 'en-us' | 'es-es';

interface LanguagesProps {
  code: Langs
  display: string
  name: string
}

export const LanguagesList: LanguagesProps[] = [
  { display: 'pt', code: 'pt-br', name: 'Português' },
  { display: 'en', code: 'en-us', name: 'English' },
  { display: 'es', code: 'es-es', name: 'Español' }
];

const getRedirectURICulture = (): Langs | null => {
  const currentUrl = new URLSearchParams(window.location.search);

  const url = currentUrl.get('redirect_uri')?.toLowerCase();

  if(!url) {
    return null;
  }

  const destParam = new URL(url).searchParams.get('dest');

  if(!destParam) {
    return null;
  }

  const decoded = decodeURIComponent(destParam);

  const params = new URLSearchParams(decoded);

  const culture = params.get('culture')

  if(!culture) {
    return null;
  }

  return culture as Langs;
} 

const getInitialLanguage = (): Langs => {
  const params = new URLSearchParams(window.location.search);

  const culture = params.get('culture')?.toLowerCase();

  const redirectCulture = getRedirectURICulture();

  const initialLanguage = (culture as Langs) || redirectCulture ||  'pt-br';

  localStorage.setItem('@auth0_culture', initialLanguage);

  return initialLanguage;
};

i18next.init({
  interpolation: { escapeValue: false },
  lng: getInitialLanguage(),
  resources: {
    ptBR,
    enUS,
    esES,
  },
  fallbackLng: {
    'pt-br': ['ptBR'],
    'en-us': ['enUS'],
    'es-es': ['esES'],
    'default': ['ptBR']
  }
});

export default i18next;
